import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Skeleton } from '../primitives/skeleton.js';
import { seriesColor } from './types.js';
/** Цветная метка ряда. Цвет — токен через inline `style`: их не перечислить классами. */
export function ChartSwatch({ color, className }) {
    return (_jsx("span", { "aria-hidden": true, className: cn('inline-block h-2.5 w-2.5 shrink-0 rounded-sm', className), style: { backgroundColor: color } }));
}
/**
 * Легенда: метка цвета + подпись ТЕКСТОВЫМ цветом (цвет ряда несёт метка,
 * не текст — иначе светлые ряды нечитаемы).
 */
export function ChartLegend({ series, className, }) {
    return (_jsx("ul", { className: cn('flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[var(--color-text-secondary)]', className), children: series.map((s, i) => (_jsxs("li", { className: "inline-flex items-center gap-1.5", children: [_jsx(ChartSwatch, { color: seriesColor(s, i) }), s.label] }, s.key))) }));
}
/** Тело тултипа: заголовок (дата/категория) и строки «метка · ряд · значение». */
export function ChartTooltipContent({ title, rows, }) {
    if (rows.length === 0)
        return null;
    return (_jsxs("div", { className: "min-w-36 rounded-[var(--radius-3)] border border-[var(--color-border-default)] bg-[var(--color-surface-canvas)] px-3 py-2 text-xs shadow-md", children: [title ? (_jsx("div", { className: "mb-1.5 font-medium text-[var(--color-text-primary)]", children: title })) : null, _jsx("ul", { className: "flex flex-col gap-1", children: rows.map((r) => (_jsxs("li", { className: "flex items-center gap-2", children: [_jsx(ChartSwatch, { color: r.color }), _jsx("span", { className: "text-[var(--color-text-secondary)]", children: r.label }), _jsx("span", { className: "ml-auto pl-3 font-medium tabular-nums text-[var(--color-text-primary)]", children: r.value })] }, r.key))) })] }));
}
/** Заглушка той же высоты, пока грузится модуль графиков (без скачка вёрстки). */
export function ChartSkeleton({ height = 240, className, }) {
    return (_jsx(Skeleton, { "aria-hidden": true, className: cn('w-full rounded-[var(--radius-3)]', className), style: { height } }));
}
/**
 * Обёртка графика: `figure` с доступным именем, область построения и
 * легенда под ней. Легенда — по умолчанию при ≥ 2 рядах (один ряд называет
 * заголовок экрана).
 */
export function ChartFrame({ ariaLabel, series, legend, className, children, onKeyDown, }) {
    const showLegend = legend ?? series.length >= 2;
    return (_jsxs("figure", { "aria-label": ariaLabel, className: cn('m-0 flex w-full flex-col gap-2', className), onKeyDown: onKeyDown, children: [children, showLegend ? _jsx(ChartLegend, { series: series }) : null] }));
}
//# sourceMappingURL=chart-parts.js.map